import requestUtils from 'api/requestUtils'
import qs from 'qs'
import { paths } from '@luxuryescapes/contract-business'

type EmployeeOrdersResponse = paths['/api/business-traveller/businesses/{businessId}/orders/employee']['get']['responses'][200]['content']['application/json']

interface Params {
  businessId: string;
  timeframe: 'upcoming' | 'past' | 'cancelled';
  page: number;
  limit: number;
  // Filter orders by if the requester is a booking manager, traveller or both
  filterBy?: 'bookingManager' | 'traveller' | 'all';
}

async function requestGetEmployeeOrders(params: Params) {
  const { businessId, timeframe, page, limit, filterBy } = params

  const queryParams = qs.stringify({
    timeframe,
    page,
    limit,
    filterBy,
  })

  try {
    const { result: orders, meta } = await requestUtils.get<EmployeeOrdersResponse>(
      `/api/business-traveller/businesses/${businessId}/orders/employee?${queryParams}`,
      { credentials: 'include', excludeBrand: true },
    )

    return {
      orders,
      meta,
    }
  } catch(error: any) {
    if (error?.status === 404) {
      return Promise.reject('No orders found')
    }
    return Promise.reject('Something went wrong')
  }
}

export default requestGetEmployeeOrders
